// Added styles for Description and TC footnote
import styled from 'styled-components';
import { font } from '../../utils/styles';

export const StyledOffersTextBlock = styled.div`
  .offer-text-block {
    .custom-text-contentBlock {
      font-family: ${font.Swiss721BTRegular};
      p {
        strong {
          font-size: 22px !important;
          font-style: normal;
          font-weight: 700;
          line-height: 125%;
        }
      }
      p {
        font-size: 16px;
        font-style: normal;
        font-weight: 500;
        line-height: 150%;
        margin-top: 1rem;
      }
      em {
        font-style: normal;
      }
      ul {
        margin-top: 1rem !important;
        padding-inline-start: 20px;
        font-size: 16px;
        font-style: normal;
        font-weight: 500;
        line-height: 150%;
      }
      div {
        font-family: ${font.Swiss721BTRegular};
      }
    }
  }
`;
